<template>
  <div>
    <el-row>
      <el-col :span="20">
        <div v-if="$bizutil.hasAnyPrivilege(['zone'])" style="float: left">
          <el-button
            style="margin-bottom: 10px"
            type="primary"
            icon="el-icon-plus"
            @click="openEditZoneDialog(true)"
            >添加分区</el-button
          >
        </div>

        <div style="margin-left: 10px; float: left">
          <div>
            <span style="font-size: 0.8rem"
              ><i
                class="el-icon-round"
                style="
                  background-color: rgb(73, 243, 73);
                  margin-right: 3px;
                  border: 1px solid rgb(27, 4, 14);
                "
              ></i
              >健康分区数：{{ zoneData.online }}</span
            >
          </div>
          <div style="margin-top: 2px">
            <span style="font-size: 0.8rem"
              ><i
                class="el-icon-round"
                style="
                  background-color: rgb(255, 65, 65);
                  margin-right: 3px;
                  border: 1px solid rgb(27, 4, 14);
                "
              ></i
              >异常分区数：{{ zoneData.offline }}</span
            >
          </div>
        </div>
        <!-- 自动开服配置 -->
        <div
          v-if="this.systemConfig.zoneAutoOpenConditions.length != 0"
          disabled
          style="
            margin-left: 100px;
            float: left;
            font-size: 0.8rem;
            border: 1px solid grey;
            border-radius: 10px;
            padding: 8px;
          "
        >
          <div style="font-size: 0.9rem; font-weight: bold">
            自动开服条件（仅需满足其一）：
          </div>
          <div
            v-for="item of this.systemConfig.zoneAutoOpenConditions"
            :key="item.seq"
          >
            - {{ getNameOfZoneAutoCondition(item.key) }} ≥ {{ item.value }}
          </div>
        </div>
        <div></div>
      </el-col>
    </el-row>
    <el-tabs v-model="tabValue" @tab-click="switchTabs">
      <el-tab-pane label="分区状态" name="zoneState">
        <ZoneStateListPage v-if="tabValue == 'zoneState'"></ZoneStateListPage>
      </el-tab-pane>
      <el-tab-pane label="分区列表" name="zoneList">
        <ZoneListPage v-if="tabValue == 'zoneList'"></ZoneListPage>
      </el-tab-pane>
      <el-tab-pane label="自动开服条件" name="zoneAutoOpenConfig">
        <ZoneAutoOpenConfigListPage
          @systemConfigChange="systemConfigChange"
          v-if="tabValue == 'zoneAutoOpenConfig'"
        ></ZoneAutoOpenConfigListPage>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";

import EditZoneDialog from "./EditZoneDialog";
import ZoneAutoOpenConfigListPage from "./tab-pages/ZoneAutoOpenConfigListPage";
import ZoneStateListPage from "./tab-pages/ZoneStateListPage";
import ZoneListPage from "./tab-pages/ZoneListPage";

export default {
  data() {
    return {
      tabValue: "zoneState",
      zoneData: {
        online: 0,
        offline: 0,
      },
      systemConfig: {
        zoneAutoOpenConditions: [],
      },
      availableConditions: [], // 可用的条件
    };
  },

  async created() {
    await this.loadZoneData();

    await this.loadAvailableConditionsOfZoneAutoOpen();
    // 拉取运营级别可查看的配置
    await this.loadSystemConfigForAdminRoleNormal();
  },

  components: {
    EditZoneDialog,
    ZoneAutoOpenConfigListPage,
    ZoneStateListPage,
    ZoneListPage,
  },

  methods: {
    /**
     * 切换tab
     */
    async switchTabs(tab, event) {
      await this.loadZoneData();
    },
    /**
     * 查询分区集合
     */
    async loadZoneData() {
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/zone/queryZoneData`,
          {},
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message.error(resData.message);
        return;
      }

      let data = resData.data || {};

      this.zoneData.online = data.onlineNumber;
      this.zoneData.offline = data.offlineNumber;
    },

    async openEditZoneDialog(isCreate, oldData) {
      this.$dialogutil.open("EditZoneDialog", {
        closedCallback: () => {},
        data: {
          value: {
            isCreate: isCreate,
            oldData: oldData,
          },
        },
      });
    },

    /**
     * 加载运营级别能够查看的系统设置
     */
    async loadSystemConfigForAdminRoleNormal() {
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/getSystemConfigForAdminRoleNormal`,
          {},
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message.error(resData.message);
        return;
      }
      this.systemConfig = resData.data || {};
    },
    /**
     * 加载可使用的自动开新区条件
     */
    async loadAvailableConditionsOfZoneAutoOpen() {
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/availableConditionsOfZoneAutoOpen`,
          {},
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message.error(resData.message);
        return;
      }
      this.availableConditions = resData.data.availableConditions || [];
    },
    systemConfigChange(newValue) {
      this.systemConfig = newValue;
    },
    getNameOfZoneAutoCondition(key) {
      for (let i = 0; i < this.availableConditions.length; i++) {
        if (key == this.availableConditions[i].value) {
          return this.availableConditions[i].label;
        }
      }
      return key;
    },

    ms2day(ts) {
      return util.ms2day(ts);
    },

    ms2ymdhm(ts) {
      return util.ms2ymdhm(ts);
    },
  },
};
</script>

<style lang="scss" scoped>
.zone-status-tag {
  display: inline-block;
  padding: 0 10px;
  border: 1px solid #d9ecff;
  border-radius: 4px;
}

.zone-status-tag-maintained {
  background-color: lightgray;
  border-color: lightgray;
}

.zone-status-tag-idle {
  background-color: chartreuse;
  border-color: chartreuse;
}

.zone-status-tag-full {
  background-color: rgb(243, 159, 159);
  border-color: red;
}

.el-icon-round {
  border-radius: 50%;
  width: 10px;
  height: 10px;
}

.link-button {
  padding-left: 10px;
  color: rgb(37, 148, 240);
  cursor: pointer;
}

::v-deep .el-table__row td {
  padding: 3px 0;
}

::v-deep .el-table .cell {
  line-height: 18px;
}
</style>